import { EMAIL_ACTION_TYPE, EmailStateItem } from 'store/email/email.type';

export const EMAIL_INIT: EmailStateItem = {
  refId: '',
  actionType: EMAIL_ACTION_TYPE.EMAIL,
  id: '',
  name: '',
  stepIdx: -1,
};
